export function outputdollars(integer) {
  integer = String(integer);
  let decimalStr = "";
  if (integer.includes(".")) {
    decimalStr = integer.split(".")[1];
    integer = integer.split(".")[0];
  }
  let formattedInteger = "";
  for (let i = integer.length - 1, count = 0; i >= 0; i--) {
    formattedInteger = integer[i] + formattedInteger;
    count = (count + 1) % 3;
    if (count === 0 && i > 0) {
      formattedInteger = "," + formattedInteger;
    }
  }
  if (decimalStr) {
    return formattedInteger + "." + decimalStr;
  }
  return formattedInteger;
}

function outputcents(decimal) {
  const value = Math.round(decimal * 100);
  return value < 10 ? ".0" + value : "." + value;
}

export function outputmoney(amount) {
  if (amount === "") return "0.00";
  amount = parseFloat(amount);
  if (isNaN(amount)) return "0.00";

  // 分离整数、小数和符号部分
  const integerPart = Math.floor(amount);
  const decimalPart = amount - integerPart;

  if (integerPart < 0)
    return "-" + outputdollars(integerPart) + outputcents(decimalPart);
  else return outputdollars(integerPart) + outputcents(decimalPart);
}

const intervals = {
  S: 1,
  M: 60,
  H: 60 * 60,
  D: 60 * 60 * 24,
  W: 60 * 60 * 24 * 7,
};
export function formatDuration(seconds, daysThreshold = 3) {
  if (seconds < intervals.M) {
    return `${seconds}秒`;
  }
  if (seconds < intervals.H) {
    const rest = seconds % intervals.M;
    if (rest) {
      return `${Math.floor((seconds - rest) / intervals.M)}分${formatDuration(
        rest
      )}`;
    }
    return `${Math.floor(seconds / intervals.M)}分钟`;
  }
  if (seconds <= intervals.D * daysThreshold) {
    const rest = seconds % intervals.H;
    if (rest) {
      return `${Math.floor((seconds - rest) / intervals.H)}时${formatDuration(
        rest
      )}`;
    }
    return `${Math.floor(seconds / intervals.H)}小时`;
  }
  if (seconds <= intervals.W) {
    const rest = seconds % intervals.D;
    if (rest) {
      return `${Math.floor((seconds - rest) / intervals.D)}天${formatDuration(
        rest
      )}`;
    }
    return `${Math.floor(seconds / intervals.D)}天`;
  }
  const rest = seconds % intervals.W;
  if (rest) {
    return `${Math.floor((seconds - rest) / intervals.W)}周${formatDuration(
      rest
    )}`;
  }
  return `${Math.floor(seconds / intervals.W)}周`;
}

// 示例用法
// console.log(formatDuration(7200)); // 输出：2小时
// console.log(formatDuration(86400)); // 输出：24小时
// console.log(formatDuration(259200)); // 输出：72小时
// console.log(formatDuration(280800)); // 输出：3天6小时
// console.log(formatDuration(2808800)); // 输出：4周4天12小时13分20秒
// console.log(formatDuration(5888888)); // 输出：9周5天3小时48分8秒
// console.log(formatDuration(3600)); // 输出：1小时
// console.log(formatDuration(3660)); // 输出：1小时1分种
// console.log(formatDuration(3599)); // 输出：59分59秒
// console.log(formatDuration(59)); // 输出：59秒
// console.log(formatDuration(0)); // 输出：0秒
